import { registerBlockType } from '@wordpress/blocks';
import { Gallery } from './gallery.js';
import { Modal } from './modal.js';

import { 
  scrollDirection, 
  clickAll,
  modals,
  popups,
  scrollToAnchor,
  simpleMouse,
  stars,
  blogActions,
  textImages,
  swiperWrapper,
  setAccordions,
  extendLinkToItem,
} from './helpers.js';

import Fullpage from './blocks/fullpage/fullpage.js';

import {Blog} from './blog.js';

if(typeof window.Gallery === 'undefined') window.Gallery = Gallery;
if(typeof window.Modal === 'undefined') window.Modal = Modal;

if(typeof window.clickAll === 'undefined') window.clickAll = clickAll;
if(typeof window.popups === 'undefined') window.popups = popups;
if(typeof window.simpleMouse === 'undefined') window.simpleMouse = simpleMouse;
if(typeof window.stars === 'undefined') window.stars = stars;
if(typeof window.blogActions === 'undefined') window.blogActions = blogActions;
if(typeof window.textImages === 'undefined') window.textImages = textImages;
if(typeof window.swiperWrapper === 'undefined') window.swiperWrapper = swiperWrapper;
if(typeof window.setAccordions === 'undefined') window.setAccordions = setAccordions;
if(typeof window.extendLinkToItem === 'undefined') window.extendLinkToItem = extendLinkToItem;

if(typeof window.Fullpage === 'undefined') window.Fullpage = Fullpage;
if(typeof window.Blog === 'undefined') window.Blog = Blog;


if(typeof afgBlocks !== 'undefined') {

  if(afgBlocks.hasOwnProperty('blocks')) {
    if(afgBlocks.blocks.length !== 0) {

      afgBlocks.blocks.forEach((block) => {

        const key = block.name;
        if(block.file.includes('src/views/')) {
          const config = require(`../views/blocks/${key}/block.json`);
          const registerKey = 'acf/' + key;
          registerBlockType(registerKey, config);
        }
      });

    }
  }
  
}

scrollDirection();
scrollToAnchor('.toanchor');
modals();
